<div class="relative block">
  <ng-content *ngIf="!isLoading"></ng-content>
  <div *ngIf="isLoading" class="p-1 flex items-center">
    <div class="spinner mr-2"></div>
    <p class="label">
      <span>{{'localLoader.loading' | translate}}</span>
      <span *ngIf="data" class="ml-0.5">{{data}}</span>
      <span>...</span>
    </p>
  </div>
</div>
